<script lang="ts">
  import { ConfirmActions, TextArea, Title } from '$shared/components';
  import Label from '$shared/constants/Label';
  import ModalEvent from '$shared/constants/ModalEvent';

  interface Props {
    loading?: boolean;
    onevent?: (payload: any) => void;
  }

  let { loading = false, onevent }: Props = $props();

  let optionalNote = $state('');

  const handleOk = () => {
    onevent?.({ type: ModalEvent.ok, data: optionalNote });
  };

  const handleCancel = () => {
    onevent?.({ type: ModalEvent.close });
  };

  const onChangeNote = (e: any): void => {
    optionalNote = e.target.value;
  };
</script>

<div class="cvo-resolve-issues-popup">
  <div data-cy="cvo-resolve-issues-title" class="title">
    <Title type="h2">Resolve missing information</Title>
  </div>
  <div class="note-input">
    <div data-cy="cvo-resolve-issues-info" class="info">
      Add an optional message for the CVO team
    </div>
    <TextArea
      name="cvo-resolve-issue-note"
      placeholder="Add message"
      value={optionalNote}
      oninput={onChangeNote}
    />
  </div>
  <div class="actions">
    <ConfirmActions {loading} okLabel={Label.Submit} onok={handleOk} oncancel={handleCancel} />
  </div>
</div>

<style>
  .cvo-resolve-issues-popup {
    padding: 24px;
    width: 400px;
  }
  .title {
    margin-bottom: 16px;
  }
  .note-input .info {
    color: var(--grey-dark);
    margin-bottom: 10px;
  }
  .actions {
    margin-top: 24px;
  }
</style>
